var _g;
import * as React from "react";
var SvgFeedbackSoftwareDevelopment = function SvgFeedbackSoftwareDevelopment(props) {
  return _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "feedback-software-development_svg__software-dev"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M14.59 52.41h28.486v3.22H14.59z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#feedback-software-development_svg__paint0_linear_13163_16357)",
    d: "m35 42.75 2.565 9.658h-17.46l2.566-9.658z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 56.209,
    height: 42.843,
    x: 0.5,
    y: 0.5,
    fill: "url(#feedback-software-development_svg__paint1_linear_13163_16357)",
    stroke: "#FBD7B2",
    opacity: 0.8,
    rx: 4.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#feedback-software-development_svg__paint2_linear_13163_16357)",
    d: "M3.583 36.65h50.043a2.64 2.64 0 0 0 1.827-.745 2.49 2.49 0 0 0 .756-1.778v5.75a2.94 2.94 0 0 1-.9 2.093 3.12 3.12 0 0 1-2.158.874H4.067a3.12 3.12 0 0 1-2.163-.87A2.94 2.94 0 0 1 1 39.875v-5.749c0 .666.272 1.306.756 1.778a2.64 2.64 0 0 0 1.827.745m23.867 3.097c0 .223.069.442.197.627.129.185.311.33.524.414a1.19 1.19 0 0 0 1.266-.255c.16-.16.269-.362.31-.582.043-.22.016-.446-.075-.651a1.13 1.13 0 0 0-.438-.5 1.184 1.184 0 0 0-1.45.161c-.21.21-.328.493-.325.786z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m19.032 26.048-8.904-5.088v-2.088l8.904-5.088 1.296 2.232-8.448 4.704v-1.608l8.448 4.704zm2.89 3.192L31.858 9.2h2.88L24.85 29.24zm15.991-3.192-1.296-2.232 8.448-4.704v1.608l-8.448-4.704 1.296-2.232 8.904 5.088v2.088z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "feedback-software-development_svg__paint0_linear_13163_16357",
    x1: 28.835,
    x2: 28.835,
    y1: 42.75,
    y2: 52.408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "feedback-software-development_svg__paint1_linear_13163_16357",
    x1: 28.895,
    x2: 29,
    y1: -16.725,
    y2: 46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C3144"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "feedback-software-development_svg__paint2_linear_13163_16357",
    x1: 28.605,
    x2: 28.605,
    y1: 34.127,
    y2: 42.844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C3144"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3144",
    stopOpacity: 0
  })))));
};
export default SvgFeedbackSoftwareDevelopment;